/** Aligned with backend `MAX_INVOICE_EMAIL_ADDRESSES`. */
export const MAX_INVOICE_EMAIL_ADDRESSES = 10;

/** Aligned with backend `MAX_INVOICE_EMAIL_SERIALIZED_LENGTH`. */
export const MAX_INVOICE_EMAIL_SERIALIZED_LENGTH = 4000;

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidInvoiceEmailSegment(value: string): boolean {
  return EMAIL_PATTERN.test(value.trim());
}

/**
 * Parses API comma-separated invoice emails: trim, dedupe case-insensitively, preserve order.
 */
export function parseInvoiceEmailsFromApi(raw: string | null | undefined): string[] {
  if (raw == null || typeof raw !== "string") {
    return [];
  }
  const seen = new Set<string>();
  const out: string[] = [];
  for (const part of raw.split(",")) {
    const t = part.trim();
    if (!t) continue;
    const key = t.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(t);
  }
  return out;
}

export function serializeInvoiceEmailsForApi(addresses: string[]): string {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const a of addresses) {
    const t = a.trim();
    if (!t) continue;
    const key = t.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(t);
  }
  return out.join(",");
}

export function formatInvoiceEmailsForDisplay(raw: string | null | undefined): string {
  const list = parseInvoiceEmailsFromApi(raw);
  if (list.length === 0) return "";
  return list.join(", ");
}
